import React, { useEffect, useState } from 'react';
import { useTheme } from '../context/ThemeContext';
// import { useNavigate } from 'react-router-dom';
import { 
    FaDatabase, FaShieldAlt, FaPython, FaAngular,
    FaGithub, FaLinkedin, FaEnvelope, FaReact, 
    FaNodeJs, FaJs, FaHtml5, FaCss3Alt, FaGitAlt,  
} from 'react-icons/fa';
// import { SiNuxtdotjs } from 'react-icons/si';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import '../styles/home.css';

const Home = () => {
  const { isDarkMode } = useTheme();
  const [activeSection, setActiveSection] = useState('hero');
  const [isLoaded, setIsLoaded] = useState(false);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  useEffect(() => {
    setIsLoaded(true);
    
    const handleScroll = () => {
      const sections = ['hero', 'about', 'work', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Scroll to top on component mount
    // window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const skillIcons = [
    { name: "React", icon: <FaReact />, color: "#61DAFB" },
    { name: "Angular", icon: <FaAngular />, color: "#00DC82" },
    { name: "Node.js", icon: <FaNodeJs />, color: "#339933" },
    { name: "JavaScript", icon: <FaJs />, color: "#F7DF1E" },
    { name: "HTML5", icon: <FaHtml5 />, color: "#E34F26" },
    { name: "CSS3", icon: <FaCss3Alt />, color: "#1572B6" },
    { name: "Database", icon: <FaDatabase />, color: "#336791" },
    { name: "Git", icon: <FaGitAlt />, color: "#F05032" },
    { name: "Python", icon: <FaPython />, color: "#339933" },
    { name: "Security", icon: <FaShieldAlt	 />, color: "#FF9900" },
  ];

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: <FaLinkedin />,
      url: 'https://www.linkedin.com/in/amal-alex-75b316156/',
      label: 'Connect with me'
    },
    {
      name: 'GitHub',
      icon: <FaGithub />,
      url: 'https://github.com/amal-alex07',
      label: 'Check out my code'
    },
    {
      name: 'Email',
      icon: <FaEnvelope />,
      url: 'mailto:amal.panackan@gmail.com',
      label: 'Send me an email'
    }
  ];

  return (
    <section className={`home-section ${isDarkMode ? 'dark-mode' : ''} ${isLoaded ? 'loaded' : ''}`}>
      <div className="home-container">
        <div className="dot-pattern"></div>
        <motion.div 
          className="hero-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero-content">
            <motion.div 
              className="hero-text"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
            >
              <div className="title-container">
                <h1 className="main-title highlight animate-title">
                  {['A', 'M', 'A', 'L', ''].map((letter, index) => (
                    <span key={index} style={{ animationDelay: `${index * 0.1}s` }}>{letter}</span>
                  ))}
                    {['','A','L','E','X'].map((letter, index) => (
                    <span key={index} style={{ animationDelay: `${index * 0.1}s` }}>{letter}</span>
                  ))}
                </h1>

                <div className="hero-description fade-in">
                  {/* I'M A SOFTWARE DEVELOPER  <br /> */}
                  Creating robust digital solutions with performance, security, and usability in mind.<br />
                  Innovative and results-driven Software Developer with a strong foundation in full-stack development and cybersecurity,<br />
                  now progressing towards technical roles.<br />
                </div>
                <div className="social-links-home fade-in">
                  <a 
                    href="https://www.linkedin.com/in/amal-alex-75b316156/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="social-link linkedin"
                    aria-label="LinkedIn Profile"
                  >
                    <FaLinkedin />
                    <span className="social-label">LinkedIn</span>
                  </a>
                  <a 
                    href="https://github.com/amal-alex07" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="social-link github"
                    aria-label="GitHub Profile"
                  >
                    <FaGithub />
                    <span className="social-label">GitHub</span>
                  </a>
                </div>
              </div>
            </motion.div>

            <motion.div 
              className="hero-image"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.4, duration: 0.8 }}
            >
              <div className="profile-image">
                <img src="/amal.png" alt="Amal" className="morph-animation" />
              </div>
            </motion.div>
          </div>
        </motion.div>

        <div id="about" className="about-section">
          <div className="section-header fade-in">
            {/* <span className="section-number">01</span> */}
          </div>
          <div className="about-content">
            <div className="skills-slider">
              <div className="skills-track">
                {[...skillIcons, ...skillIcons].map((skill, index) => (
                  <div 
                    key={index}
                    className="skill-icon-box"
                    style={{ '--skill-color': skill.color }}
                  >
                    <div className="skill-icon-wrapper">
                      {skill.icon}
                    </div>
                    <span className="skill-name">{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
